import { TypographyV3 } from '@jouzen/ecom-components';
import { cx } from 'class-variance-authority';
import { useTranslations } from 'next-intl';

import type { ImageProps } from '@/app/components/Image';
import Image from '@/app/components/Image';

interface AccoladeCardProps {
  readonly contentClass?: string;
  readonly logoClass?: string;
  readonly year: string;
  readonly heading: string;
  readonly image: ImageProps;
}

const AccoladeCard = ({
  contentClass = 'pb-6',
  logoClass = 'pb-9',
  year,
  heading,
  image,
}: AccoladeCardProps): JSX.Element => {
  const t = useTranslations();
  return (
    <div className="relative flex flex-1 flex-col justify-between rounded-lg bg-sandstone-300 p-6">
      <div className={contentClass}>
        <TypographyV3 weight="bold">{year}</TypographyV3>
        <TypographyV3 variant="body-large">{t(heading)}</TypographyV3>
      </div>
      <div
        className={cx(
          'w-full border-t-2 border-sandstone-500 border-opacity-10 pt-6',
          logoClass,
        )}
      >
        <Image
          {...image}
          data-cy="accolade-logo"
          format={image.format ?? 'png'}
          width={image.width ?? 170}
          height={image.height ?? 33}
        />
      </div>
    </div>
  );
};

export default AccoladeCard;
